let backendUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_BASE_URL : 'http://localhost:8000/api';
let frontendUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL : 'http://localhost:3000'
let downloadUrl = 'http://localhost:4005';
let env = process.env.NODE_ENV;

export const backend_url = backendUrl;
export const frontend_url = frontendUrl;
export const download_url = downloadUrl;
export const environment = env;